module.exports = __webpack_public_path__ + "static/media/info-primary.90f92478.svg";